import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import EquipmentForm from "./equipmentform";
import { dash } from "./displayValue";
import "../component/css/listing-table.css";

// Renders one <tr>. The parent owns the <table>, <colgroup> and <thead> so the
// header and every row share one column grid - previously each record rendered
// its own table and nothing lined up.
function PartsInventory(props) {
  const navigate = useNavigate();
  const [showInquiryModal, setShowInquiryModal] = useState(false);

  const handleDetailsClick = () => {
    navigate("/inventoryDetails", { state: { equipmentData: props } });
    window.parent.postMessage({ messageType: "scrolltop", data: 0 }, "*");
  };

  const handleInquireButtonClick = () => setShowInquiryModal(true);
  const handleCloseInquiryModal = () => setShowInquiryModal(false);

  const row = props.data || {};

  return (
    <tr>
      <td className="cell-id">{dash(props.jad_id)}</td>
      <td>{dash(row["Product_Description"])}</td>
      <td>{dash(row["Manufacturer_Id"])}</td>
      <td>{dash(props.Parts_number)}</td>
      <td>{dash(props.Revision)}</td>
      <td className="cell-actions">
        <div className="listing-actions">
          <button className="more-details-btn" onClick={handleDetailsClick}>
            MORE DETAILS
          </button>
          <button className="inquire-btn" onClick={handleInquireButtonClick}>
            INQUIRE
          </button>
        </div>
        {/* EquipmentForm portals to document.body and returns null when closed,
            so keeping it inside the cell does not affect the table layout. */}
        <EquipmentForm
          showInquiryModal={showInquiryModal}
          handleCloseInquiryModal={handleCloseInquiryModal}
          values={props}
          producttype="inventory"
        />
      </td>
    </tr>
  );
}

export default PartsInventory;
